/**
 * @fileoverview Constants for Product Component Library deployments
 */

import { TRP_DOMAINS } from '@trp-dms-digital-shared/ds-ui-library-common';

import type { PopUrls } from './types';

/**
 * POP URL base after TRP Domain
 */
export const POP_URL_ROOT_PATH =
  'products/product-ui/product-component-library';

/**
 * POP BETA URL base after TRP Domain
 */
export const POP_URL_ROOT_PATH_BETA =
  'beta/products/product-ui/product-component-library';

/**
 * POP URL base for versioned releases after TRP Domain
 */
export const POP_URL_ROOT_VERSIONED = `${POP_URL_ROOT_PATH}/versioned`;

/**
 * POP BETA URL base for versioned releases after TRP Domain
 */
export const POP_URL_ROOT_VERSIONED_BETA = `${POP_URL_ROOT_PATH_BETA}/versioned`;

/**
 * root URLs for the POP in the CDN
 */
export const PopCDNRootUrls: PopUrls = {
  DEV: new URL(POP_URL_ROOT_PATH, TRP_DOMAINS.DEV).href,
  BETA: new URL(POP_URL_ROOT_PATH_BETA, TRP_DOMAINS.STAGE).href,
  STAGE: new URL(POP_URL_ROOT_PATH, TRP_DOMAINS.STAGE).href,
  PROD: new URL(POP_URL_ROOT_PATH, TRP_DOMAINS.PROD).href,
};

/**
 * root URLs for the POP `versioned` URLs in the CDN
 */
export const POP_URL_ROOTS: PopUrls = {
  DEV: new URL(POP_URL_ROOT_VERSIONED, TRP_DOMAINS.DEV).href,
  BETA: new URL(POP_URL_ROOT_VERSIONED_BETA, TRP_DOMAINS.STAGE).href,
  STAGE: new URL(POP_URL_ROOT_VERSIONED, TRP_DOMAINS.STAGE).href,
  PROD: new URL(POP_URL_ROOT_VERSIONED, TRP_DOMAINS.PROD).href,
};
